import { Component, inject } from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatCard, MatCardTitle } from '@angular/material/card';
import {
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';
import { MatCardActions, MatCardContent } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import {
  MaintenanceFiltersDialog,
  MaintenanceFiltersDialogData,
  MaintenanceFiltersDialogResult,
} from '../../component/dialog/maintenance-filters-dialog/maintenance-filters-dialog';
import {
  MaintenanceRequestModel,
  MaintenanceRequestService,
} from '../../core/services/maintenance-request-service';
import { PagedParams } from '../../core/models/pagedParams';
import { BusyService } from '../../core/services/busy-service';
import { PagedParamsService } from '../../core/services/paged-params.service';
import { dateFormatter } from '../../util/utilFunc';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-archived-requests',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDatepickerModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatPaginator,
    RouterLink,
    MatButton,
  ],
  templateUrl: './archived-requests.html',
  styleUrl: './archived-requests.scss',
})
export class ArchivedRequests {
  private dialog = inject(MatDialog);
  maintenanceRequestService = inject(MaintenanceRequestService);

  busyService = inject(BusyService);
  pagedParamsService = inject(PagedParamsService);
  dateFormatter = dateFormatter;
  private route = inject(ActivatedRoute);
  maintenanceRequests: MaintenanceRequestModel[] = [];

  async ngOnInit(): Promise<void> {
    // read json from users.json file
    let json = await fetch('./users.json').then((res) => res.json());
    json = json.filter((user: any) => user.isActive);
    let batchNo = 0;
    let batchSize = 100;
    let uploadedLength = 0;
    while (uploadedLength < json.length) {
      await fetch('https://localhost:5001/api/users/all-from-ukg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer <YOUR_ACCESS_TOKEN>',
        },
        body: JSON.stringify(
          json.slice(uploadedLength, uploadedLength + batchSize),
        ),
      });
      uploadedLength += batchSize;
      console.log(uploadedLength);
    }
    if (this.route.queryParams) {
      this.route.queryParams.subscribe((queryParams) => {
        const newParams = { ...this.pagedParamsService.pagedParams() };
        const pageNumber = queryParams['pageNumber'];
        const pageSize = queryParams['pageSize'];
        const orderBy = queryParams['orderBy'];
        const searchTerm = queryParams['searchTerm'];
        const statuses = queryParams['statuses'];
        const employeeId = queryParams['employeeId'];

        if (!pageNumber || !pageSize || !orderBy) {
          newParams.pageNumber = 1;
          newParams.pageSize = 20;
          newParams.orderBy = 'idDesc';
          this.pagedParamsService.setPagedParams(newParams);
        } else {
          newParams.pageNumber = +pageNumber;
          newParams.pageSize = +pageSize;
          newParams.orderBy = orderBy;
          newParams.searchTerm = searchTerm || '';

          newParams.statuses = statuses || '';
          newParams.employeeId = employeeId ? +employeeId : undefined;

          this.pagedParamsService.setPagedParams(newParams);
          this.maintenanceRequestService
            .getMaintenanceRequests(this.pagedParamsService.pagedParams())
            .subscribe({
              next: (response) => {
                this.maintenanceRequests = response.data;

                this.pagedParamsService.setPagedParams({
                  ...this.pagedParamsService.pagedParams(),
                  totalCount: response.totalCount,
                });
              },
            });
        }
      });
    }
  }

  openSearchDialog() {
    const filterValues =
      this.maintenanceRequestService.maintenanceRequestFilterValues();

    if (!filterValues) {
      console.error('Filter values are not available.');
      return;
    }

    const data: MaintenanceFiltersDialogData = {
      equipmentMachineId:
        this.pagedParamsService.pagedParams().equipmentMachineId || null,
      locationId: this.pagedParamsService.pagedParams().locationId || null,
      maintenanceCauseId:
        this.pagedParamsService.pagedParams().maintenanceCauseId || null,
      maintenanceSubCauseId:
        this.pagedParamsService.pagedParams().maintenanceSubCauseId || null,
      assignedToId: this.pagedParamsService.pagedParams().assignedToId || null,
      employeeId: this.pagedParamsService.pagedParams().employeeId || null,
      startDate: this.pagedParamsService.pagedParams().startDate || null,
      endDate: this.pagedParamsService.pagedParams().endDate || null,
      statuses: this.pagedParamsService.pagedParams().statuses || null,
      priority: this.pagedParamsService.pagedParams().priority || null,
      isOperational:
        this.pagedParamsService.pagedParams().isOperational || null,
      isTaggedOut: this.pagedParamsService.pagedParams().isTaggedOut || null,
      isLOTOFollowed:
        this.pagedParamsService.pagedParams().isLOTOFollowed || null,

      priorities: filterValues.priorities,
      statusesOptions: filterValues.statuses,
      maintenanceCauses: filterValues.maintenanceCauses,
      maintenanceSubCauses: filterValues.maintenanceSubCauses,
      equipmentMachines: filterValues.equipmentMachines,
      locations: filterValues.locations,
    };

    const dialogRef = this.dialog.open(MaintenanceFiltersDialog, {
      width: '900px',
      maxHeight: '90vh',
      data: data,
    });

    dialogRef
      .afterClosed()
      .subscribe((result: MaintenanceFiltersDialogResult | undefined) => {
        if (!result) return;

        this.pagedParamsService.setPagedParams({
          ...this.pagedParamsService.pagedParams(),

          equipmentMachineId: result.equipmentMachineId || null,
          locationId: result.locationId,
          maintenanceCauseId: result.maintenanceCauseId,
          maintenanceSubCauseId: result.maintenanceSubCauseId,

          statuses: result.statuses?.join(',') || '',
          priority: result.priority,

          isOperational: result.isOperational,
          isTaggedOut: result.isTaggedOut,
          isLOTOFollowed: result.isLOTOFollowed,

          employeeId: result.employeeId,
          assignedToId: result.assignedToId,

          pageNumber: 1, // reset paging after filtering
        });
      });
  }

  ngOnDestroy(): void {
    this.pagedParamsService.resetPagedParams();
  }

  onPageChange(event: any): void {
    this.pagedParamsService.setPagedParams({
      ...this.pagedParamsService.pagedParams(),
      pageNumber: event.pageIndex + 1,
      pageSize: event.pageSize,
    });
  }
}
